import { css } from '@eti/styles';
import { rowItemSize } from '../../utils/styles';
import { jsx as _jsx } from "react/jsx-runtime";
const aisleStyles = css`
  align-items: center;
  display: flex;
  font-size: 0.75rem;
  justify-content: center;
  ${rowItemSize};
`;
const Aisle = _ref => {
  let {
    row
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: aisleStyles,
    "data-testid": "aisle",
    children: parseInt(String(row), 10) > 0 && row
  });
};
export default Aisle;